import { ContentType } from '@standardnotes/domain-core';
import { ComponentArea } from '../Component/ComponentArea';
export function isThemeFeatureDescription(feature) {
    return 'content_type' in feature && feature.content_type === ContentType.TYPES.Theme;
}
export function isIframeComponentFeatureDescription(feature) {
    return ('content_type' in feature &&
        feature.content_type === ContentType.TYPES.Component &&
        [ComponentArea.Editor, ComponentArea.EditorStack].includes(feature.area));
}
export function isEditorFeatureDescription(feature) {
    return (feature.note_type != undefined ||
        feature.area === ComponentArea.Editor);
}
